<template>
    <v-autocomplete :items="items" :label="label + (required ? ' *': '')" :multiple="multiple" :rules="rules" small-chips :clearable="!required&&!multiple" :deletable-chips="multiple" @input="$emit('input', JSON.stringify($event))"></v-autocomplete>
</template>

<script>
    export default {
        name: 'GenericSelectField',
        props: {
            label: String,
            required: Boolean,
            items: Array,
            multiple: Boolean,
        },
        computed: {
            rules() {
                return [
                    v => !this.required || !this.multiple && !!v ||this.multiple && v.length>0 || this.$t('login.fields.rules.required')
                ]
            }
        }
    };
</script>

<style scoped>

</style>